import React, { useEffect, useState } from "react";
import { personLabel } from "../../lib/teamManagement";

/**
 * Създаване на екип / Преименуване на екип.
 *
 * A Manager is chosen ONLY at creation, and only from the eligible list the
 * server built: active, role мениджър, and not already managing another active
 * team. There is no free-text member field anywhere — a person is addressed by
 * their membership id, never by an e-mail address.
 */
export const TeamFormDialog = ({
  open,
  mode,
  team,
  managers,
  submitting,
  error,
  onCancel,
  onSubmit,
}) => {
  const [name, setName] = useState("");
  const [managerId, setManagerId] = useState("");

  useEffect(() => {
    if (!open) return;
    setName(mode === "rename" ? team?.name || "" : "");
    setManagerId("");
  }, [open, mode, team?.id, team?.name]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape" && !submitting) onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, submitting, onCancel]);

  if (!open) return null;

  const creating = mode === "create";
  const trimmed = name.trim();
  const ready = trimmed.length >= 2 && (!creating || !!managerId);

  return (
    <div className="qw-modal-backdrop">
      <div
        className="qw-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="team-form-title"
        data-testid="team-form-dialog"
      >
        <div className="h" id="team-form-title">
          {creating ? "Създаване на екип" : "Преименуване на екип"}
        </div>
        <div className="body">
          <div className="qw-field">
            <label htmlFor="team-form-name">Име на екипа</label>
            <input
              id="team-form-name"
              className="qw-input"
              value={name}
              maxLength={80}
              onChange={(e) => setName(e.target.value)}
              disabled={submitting}
              data-testid="team-form-name"
            />
          </div>

          {creating && (
            <div className="qw-field" style={{ marginTop: 12 }}>
              <label htmlFor="team-form-manager">Мениджър</label>
              <select
                id="team-form-manager"
                className="qw-select"
                value={managerId}
                onChange={(e) => setManagerId(e.target.value)}
                disabled={submitting}
                data-testid="team-form-manager"
              >
                <option value="">Изберете мениджър</option>
                {(managers || []).map((m) => (
                  <option
                    key={m.member_id}
                    value={m.member_id}
                    data-testid={`team-form-manager-option-${m.member_id}`}
                  >
                    {personLabel(m)}
                  </option>
                ))}
              </select>
              {(managers || []).length === 0 && (
                <div className="qw-help" data-testid="team-form-no-managers">
                  Няма свободен мениджър. Всеки активен мениджър вече управлява екип.
                </div>
              )}
            </div>
          )}

          {error && (
            <div className="qw-error" role="alert" style={{ marginTop: 10 }} data-testid="team-form-error">
              {error}
            </div>
          )}
        </div>
        <div className="footer">
          <button
            type="button"
            className="qw-btn ghost"
            onClick={onCancel}
            disabled={submitting}
            data-testid="team-form-cancel"
          >
            Отказ
          </button>
          <button
            type="button"
            className="qw-btn primary"
            onClick={() => onSubmit({ name: trimmed, manager_member_id: managerId })}
            disabled={submitting || !ready}
            data-testid="team-form-submit"
          >
            {submitting ? "Записване…" : creating ? "Създай екип" : "Запази"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TeamFormDialog;
